import classNames from 'classnames';

import DocumentHorizontalCard from '../cards/DocumentHorizontalCard';

import styles from '../../styles/ads/document-card-ad.module.css';

interface DocumentCardAdProps {
    title: string;
    image: string;
    className?: string;
}

function DocumentCardAd({ title, image, className }: DocumentCardAdProps) {
    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.inner}>
                <DocumentHorizontalCard
                    title={title}
                    image={{
                        url: image,
                    }}
                />
            </div>
        </div>
    );
}

export default DocumentCardAd;
